import { combineReducers } from 'redux';

import { reducer as httpRequestReducer } from '@travel/http-request';
import { reducer as i18nReducer } from '@travel/i18n';

import routerReducer from './__router/reducer';
import authCodeReducer from './authCode/reducer';
import bannerReducer from './banner/reducer';
import chatReducer from './chat/reducer';
import commonErrorReducer from './commonError/reducer';
import furusatoNozeiReducer from './furusatoNozei/reducer';
import notificationReducer from './notification/reducer';
import pitariReducer from './pitari/reducer';
import rakutenMobileReducer from './rakutenMobile/reducer';
import reservationsDetailsReducer from './reservationsDetails/reducer';
import reservationsListReducer from './reservationsList/reducer';
import userAgentReducer from './userAgent/reducer';

export default combineReducers({
  _i18n: i18nReducer,
  _httpRequest: httpRequestReducer,
  router: routerReducer,
  commonError: commonErrorReducer,
  userAgent: userAgentReducer,
  authCode: authCodeReducer,
  reservationsList: reservationsListReducer,
  reservationsDetails: reservationsDetailsReducer,
  pitari: pitariReducer,
  banner: bannerReducer,
  furusatoNozei: furusatoNozeiReducer,
  rakutenMobile: rakutenMobileReducer,
  notification: notificationReducer,
  chat: chatReducer,
});
